import { render, staticRenderFns } from "./NotaFiscal.vue?vue&type=template&id=127075e2&scoped=true&"
import script from "./NotaFiscal.vue?vue&type=script&lang=js&"
export * from "./NotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./NotaFiscal.vue?vue&type=style&index=0&id=127075e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127075e2",
  null
  
)

export default component.exports